(function() {
    em.cloudflare = {};

    em.cloudflare.init = function() {};

    em.cloudflare.getCountry = function( callback ) {

        $.get('https://www.cloudflare.com/cdn-cgi/trace', function(data) {
            var lines = data.split("\n");

            if (lines.length > 0) {
                var loc = lines.find( function(l){ return l.split('=')[0] === 'loc';} );
                if (loc && typeof callback == 'function') {
                    var countryCode = loc.split('=')[1];
                    callback( countryCode );
                }
            }
        });
    };

    em.userNotice = {};
    em.userNotice.el = false;

    em.userNotice.init = function() {
        // window.addEventListener('DOMContentLoaded', function() {
        $( document ).ready(function() {
            if ( ! em.userNotice.capture() ) {
                return false; // user notice not present
            }

            // check the cookie
            var country = em.userNotice.getCookie('em-user-notice-country');
            var delayTime =  em.userNotice.el.getAttribute('data-time') * 1000;

            if ( country ) {
                setTimeout(function(){
                    em.userNotice.show( country ); // using user country from cookie
                }, delayTime);
            } else {
                // try to get user country by IP from Cloudflare
                em.cloudflare.getCountry( function( country ) {
                    em.userNotice.setCookie('em-user-notice-country', country);
                    setTimeout(function(){
                        em.userNotice.show( country );
                    }, delayTime);
                });
            }
        });
    };

    em.userNotice.capture = function() {

        var el = document.querySelector('.c-user-notice');
        if ( el !== null ) {
            em.userNotice.el = el;
            return el;
        }

        return false;
    };

    em.userNotice.show = function( country ) {

        $notice = $( em.userNotice.el );

        var screenWidth = $(window).width();

        // To this we could add also some cookie that indicated that even if it wasn't dismissed it was visited
        var noticeDismissed = em.userNotice.getCookie('em-user-notice-dismissed');

        // choose the content
        var countryFound = 0;
        var allCountries = 0;
        $notice.find('*[data-country]').each(function(){

            var desiredCountry = this.getAttribute('data-country');
            showOnlyOnce = this.getAttribute('data-'+desiredCountry);
            showOnlyOnDesktop = this.getAttribute('data-show-desktop-'+country);

            // console.log("Country is: "+ country + " Show only once: " + showOnlyOnce + " Notice dismissed: " + noticeDismissed + " and desired country: " + desiredCountry);

            if ( showOnlyOnDesktop && screenWidth < 767) return false;

            if ( desiredCountry == country && (!showOnlyOnce || !noticeDismissed) ) {
                $(this).show();
                countryFound = 1;
                // console.log("Con 1");
            } else if( desiredCountry == "all" && (!showOnlyOnce || !noticeDismissed) ){
                $(this).show();
                allCountries = 1;
                // console.log("Con 2");
            } else {
                $(this).hide();
            }
      });

      if ( ! countryFound && !allCountries ) {
          return false;
      }

      // show User Notice & set click handlers
      $notice
        .removeClass('is-dismissed')
        .on('click', '.c-user-notice__close', function() {
            $notice.addClass('is-dismissed');
            em.userNotice.setCookie('em-user-notice-dismissed', 1);
        })
        .on('click', 'a', function( event ) {
            $notice.addClass('is-dismissed');

            if (event.target.getAttribute('href') == '#') {
                event.preventDefault();
            }
        });
    };

    em.userNotice.unDismiss = function() {
        em.userNotice.eraseCookie('em-user-notice-dismissed');
    };

    em.userNotice.setCookie = function(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    };

    em.userNotice.getCookie = function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    };

    em.userNotice.eraseCookie = function(name) {
        document.cookie = name+'=; Max-Age=-99999999;';
    };

})();